import * as constants from '../constants'

const INITIAL_STATE = {
    editReminders: [],
    edit: false
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case constants.EDIT_REMINDER:
            return {
                ...state,
                editReminders: action.payload,
                edit: true
            };
        case constants.EMPTY_REMINDER:
            return {
                ...state,
                editReminders: [],
                edit: false
            };
        default:
            return state;
    }
};
